type ResellerColliType = {
    id?: string
    name?: string
}

type ResellerLike<T extends ResellerColliType> = {
    settings?: {
        orders?: {
            colliTypes?: T[]
            defaultColliTypes?: string[]
        }
    }
}

type CustomerLike = {
    settings?: {
        orders?: {
            allowedColliTypes?: string[]
        }
    }
}

/**
 * The colli types a customer may use, following the same rules as the main application.
 */
export function getAllowedColliTypes<T extends ResellerColliType>(reseller?: ResellerLike<T>, customer?: CustomerLike): T[] {
    const resellerColliTypes = reseller?.settings?.orders?.colliTypes || []
    const customerAllowedColliTypes = customer?.settings?.orders?.allowedColliTypes
    const defaultColliTypes = reseller?.settings?.orders?.defaultColliTypes

    return Array.isArray(customerAllowedColliTypes) ?
        resellerColliTypes.filter((type) => customerAllowedColliTypes.includes(type.id)) :
        resellerColliTypes.filter((type) => !Array.isArray(defaultColliTypes) || defaultColliTypes.includes(type.id))
}
